<template>
  <div>
    <vue-ueditor-wrap
      ref="myEditor"
      v-model="content"
      editor-id="editor-with-xiumi"
      :config="editorConfig"
    ></vue-ueditor-wrap>
  </div>
</template>
<script>
import VueUeditorWrap from "vue-ueditor-wrap";
import { myConfig } from "./editorConfig.js";
export default {
  name: "UEditor",
  props: {
    value: {
      type: String,
      default: "",
    },
  },
  components: {
    VueUeditorWrap,
  },
  data() {
    return {
      content: "",
      editorConfig: myConfig,
    };
  },
  watch: {
    value(val) {
      this.content = val;
    },
    content(val) {
      this.$emit("change", val);
    },
  },
  mounted() {
    this.content = this.value;
  },
  created() {},
  methods: {},
};
</script>
<style lang="css">
</style>
